
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Bookpunetodevkundcab() {



    const cardData =
    {
        keyword: 'Pune to Devkund Taxi Services',
        heading: 'S9 Travels: Pune to Devkund Taxi Services',
        headingDescription: 'S9 Travels offers reliable, comfortable, and affordable taxi services from Pune to Devkund. Whether you are planning an adventure to the famous waterfall, a nature retreat, or a relaxing weekend getaway, our well-maintained fleet and professional drivers ensure a smooth and hassle-free journey. Devkund is approximately 120 km from Pune, and the journey takes around 3 to 4 hours by road. Enjoy a safe and comfortable ride with our top-notch amenities and customer-centric service.',

        top: 'Top Places to Visit in Devkund with S9 Travels',

"topPlaces": [
    {
        "title": "Devkund Waterfall",
        "description": "The Devkund Waterfall is the main attraction of this serene destination. A popular trekking spot, the waterfall is surrounded by lush forests and offers a peaceful atmosphere. The trek to the waterfall is relatively easy but requires a bit of endurance, making it an ideal destination for adventure lovers and nature enthusiasts."
    },
    {
        "title": "Trekking Trails",
        "description": "Devkund is renowned for its scenic trekking routes that take you through dense forests and picturesque landscapes. The trekking trails lead to various viewpoints offering spectacular views of the surrounding mountains, rivers, and valleys, making it a perfect spot for both seasoned trekkers and beginners."
    },
    {
        "title": "Bhivpuri Waterfalls",
        "description": "A short drive from Devkund, Bhivpuri Waterfalls is another popular destination for nature lovers. The waterfall is a great spot for picnics and offers a refreshing escape. The surrounding greenery and peaceful ambiance make it an ideal place for relaxation."
    },
    {
        "title": "Kondhane Caves",
        "description": "Kondhane Caves, located near Devkund, are ancient Buddhist rock-cut caves that are believed to date back to the 1st century BCE. The caves are an archaeological marvel, and exploring them offers insight into the history of Buddhism in the region. The scenic beauty surrounding the caves adds to the experience."
    },
    {
        "title": "Forts around Devkund",
        "description": "The area around Devkund is rich in history, with several ancient forts to explore. Some of the nearby forts, such as Matheran Fort and Raireshwar Fort, offer a combination of adventure, history, and panoramic views of the Western Ghats."
    },
    {
        "title": "Raireshwar Fort",
        "description": "Raireshwar Fort is located in the vicinity of Devkund and is known for its historical significance and scenic beauty. The fort offers a challenging trek and provides panoramic views of the Sahyadri mountains. It’s an excellent choice for history buffs and trekking enthusiasts."
    },
    {
        "title": "Matheran",
        "description": "Matheran, although slightly further from Devkund, is another beautiful hill station worth visiting. Famous for its serene beauty, Matheran offers numerous viewpoints, lush green forests, and peaceful walking trails, making it an ideal getaway for nature lovers."
    },
    {
        "title": "Pinewood Resort",
        "description": "If you're looking for a relaxing and rejuvenating stay, Pinewood Resort near Devkund offers comfortable accommodations amidst nature. The resort is perfect for unwinding and enjoying the peaceful surroundings, making it a great place to stay after a day of trekking and sightseeing."
    },
    {
        "title": "Bhor Ghat",
        "description": "Bhor Ghat is a mountain pass located near Devkund. Known for its scenic beauty, it offers stunning views of the Western Ghats and is an ideal spot for photography and nature walks. It’s a perfect place for nature lovers who want to enjoy the serene landscapes and quiet ambiance."
    },
    {
        "title": "Bhimashankar Wildlife Sanctuary",
        "description": "A short distance away from Devkund, the Bhimashankar Wildlife Sanctuary is a must-visit for wildlife and nature enthusiasts. The sanctuary is home to diverse flora and fauna and offers a peaceful retreat amidst nature. The sanctuary is also known for its trekking trails and beautiful landscapes."
    }
],

"services": [
  {
    "name": "Pune to Devkund Taxi",
    "description": "S9 Travels offers comfortable and reliable taxi services for your journey from Pune to Devkund. Whether you're visiting for leisure or nature exploration, enjoy a smooth and hassle-free ride. Book your Pune to Devkund taxi today!"
  },
  {
    "name": "Pune to Devkund Cab Service",
    "description": "Choose S9 Travels for a professional and dependable cab service from Pune to Devkund. Our experienced drivers and well-maintained vehicles ensure a comfortable, safe, and enjoyable journey."
  },
  {
    "name": "Pune to Devkund Taxi Booking",
    "description": "Booking a taxi from Pune to Devkund is simple with S9 Travels. Whether you prefer booking online or via phone, we offer flexible and easy booking options to suit your needs. Make your trip stress-free by booking with us!"
  },
  {
    "name": "Pune to Devkund One-Way Taxi",
    "description": "S9 Travels offers affordable and reliable one-way taxi services for your journey from Pune to Devkund. Enjoy a direct, comfortable ride to your destination without the hassle of returning. Get in touch for a convenient and timely one-way ride."
  },
  {
    "name": "Pune to Devkund Round Trip",
    "description": "For a round trip from Pune to Devkund, S9 Travels provides flexible and convenient options. We ensure that your journey is comfortable and timely, with professional drivers and quality vehicles to make your round trip hassle-free."
  },
  {
    "name": "Pune to Devkund Car Rental",
    "description": "Looking for a car rental for your Pune to Devkund trip? S9 Travels offers flexible car rental services, allowing you to travel at your own pace. Choose from a wide range of vehicles to suit your preferences and travel needs."
  },
  {
    "name": "Pune to Devkund Drop Taxi",
    "description": "Need a drop-off taxi service from Pune to Devkund? S9 Travels offers reliable drop taxi services, ensuring you reach your destination comfortably and on time. Enjoy a peaceful, stress-free ride to Devkund."
  },
  {
    "name": "Pune to Devkund Luxury Taxi",
    "description": "For a premium and luxurious travel experience, S9 Travels offers luxury taxi services for your Pune to Devkund trip. Enjoy enhanced comfort, extra space, and a smooth, luxurious ride with our top-class vehicles and professional drivers."
  }
],


"tableData": [
  ["Book Pune To Devkund Taxi", "Book Pune To Devkund Cab Service"],
  ["Book Pune To Devkund Taxi Booking", "Book Pune To Devkund One-Way Taxi"],
  ["Book Pune To Devkund Round Trip", "Book Pune To Devkund Car Rental"],
  ["Book Pune To Devkund Drop Taxi", "Book Pune To Devkund Luxury Taxi"]
],
"whychoose": [
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "At S9 Travels, we understand the importance of time when traveling from Pune to Devkund. Whether you’re going for a scenic waterfall trek or a peaceful getaway, our drivers ensure timely pickups and drop-offs to keep your trip worry-free and on schedule."
  },
  {
    "WhyChooseheading": "Comfortable and Spacious Vehicles",
    "WhyChoosedescription": "We offer a wide range of comfortable vehicles for your journey to Devkund. Our well-maintained cars, equipped with air conditioning and spacious seating, guarantee a comfortable and enjoyable ride throughout your trip."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our drivers are not only experienced in long-distance travel but also familiar with the best routes to Devkund. Their professionalism ensures a safe, smooth, and comfortable journey, allowing you to relax and enjoy the ride."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "S9 Travels offers affordable, competitive pricing for your Pune to Devkund trip. We provide transparent pricing with no hidden charges, ensuring that you are aware of all costs upfront for a hassle-free experience."
  },
  {
    "WhyChooseheading": "Safe and Comfortable Journey",
    "WhyChoosedescription": "Your safety is our priority. Our vehicles are equipped with modern safety features such as airbags, seat belts, and GPS tracking, ensuring that you have a secure and smooth journey throughout your trip."
  },
  {
    "WhyChooseheading": "24/7 Availability",
    "WhyChoosedescription": "S9 Travels operates around the clock, offering flexible travel options whether you're planning an early morning trip or a late-night return. Our customer service team is available at any time to assist you with your travel needs."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking Process",
    "WhyChoosedescription": "Booking your Pune to Devkund cab is simple and convenient. You can easily make a reservation via our website or mobile app, or contact our customer service team for personalized booking assistance."
  },
  {
    "WhyChooseheading": "Customized Travel Packages",
    "WhyChoosedescription": "Whether you’re visiting Devkund for a nature trek or a peaceful retreat, we offer customized travel packages to suit your preferences. Let us know your needs, and we’ll ensure a tailored travel experience that meets your expectations."
  }
]










    }




    const faqData = [
        [
          {
            question: 'How can I book a Pune to Devkund cab with S9 Travels?',
            answer: 'Booking your cab is easy! You can reserve online through our website or mobile app, or contact our customer service team for personalized assistance.',
          },
          {
            question: 'Are the drivers experienced for long-distance travel?',
            answer: 'Yes, our drivers are experienced and skilled in long-distance travel, ensuring a smooth and safe ride to Devkund.',
          },
          {
            question: 'What types of vehicles are available for Pune to Devkund travel?',
            answer: 'We offer a range of well-maintained vehicles including sedans, SUVs, and premium cars, all designed for comfort on long journeys to Devkund.',
          },
          {
            question: 'How do I pay for my Pune to Devkund cab rental?',
            answer: 'We offer various payment options, including cash, credit/debit cards, and online payments through our app, making it easy for you to pay.',
          },
          {
            question: 'Can I book a round trip from Pune to Devkund?',
            answer: 'Yes, we offer round-trip services. Just provide us with your return details, and we’ll ensure your trip is as convenient as possible.',
          },
          {
            question: 'Are there any extra charges for waiting or detours?',
            answer: 'If there are any extra charges, such as for waiting time or detours, we will inform you upfront, ensuring complete transparency in pricing.',
          },
          {
            question: 'Can I hire a cab for sightseeing in Devkund?',
            answer: 'Yes, we offer sightseeing tours in Devkund. Visit the famous Devkund Waterfall and enjoy the beauty of nature with our professional drivers.',
          },
          {
            question: 'What is the luggage allowance for a Pune to Devkund cab?',
            answer: 'Our vehicles can comfortably accommodate standard luggage. If you have extra luggage or special requirements, please inform us during the booking process, and we will make the necessary arrangements.',
          },
          {
            question: 'Is S9 Travels available for corporate travel between Pune and Devkund?',
            answer: 'Yes, we offer corporate travel services, including group trips or business-related visits, between Pune and Devkund.',
          },
          {
            question: 'Why should I choose S9 Travels for Pune to Devkund travel?',
            answer: 'With S9 Travels, you can expect a reliable, comfortable, and affordable journey. Our professional drivers, well-maintained vehicles, and transparent pricing ensure a safe, smooth, and enjoyable trip every time.',
          },
        ]
      ];
      
      const testimonialsData = [
        {
          name: 'Mr. Vinayak Jadhav',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],  
          text: '“I had an amazing experience traveling to Devkund with S9 Travels. The driver was professional, the car was comfortable, and the journey was smooth. I’ll definitely book with them again for my future trips!”',
        },
        {
          name: 'Mrs. Meera Deshpande',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],  
          text: '“Our trip to Devkund was made much easier with S9 Travels. The vehicle was spacious, the driver was friendly, and we reached Devkund on time, all thanks to their reliable service. Highly recommend them!”',
        },
      ];
      
      
      
    
    
    
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8850328441",
            "+91 9552526916",

        ],
        email: "booking@s9travels.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Book Pune To Nashik Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Book Pune To Ganpatipule Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Book Pune To Ratnagiri Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Book Pune To Devkund Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Book Pune To Goa Cab Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Book Pune To Kolhapur Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Book Pune To Lonavala Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Book Pune To Alibaug Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Book Pune To Aurangabad Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Book Pune To Bhimashankar Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Book Murud Janjira Cab From Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Book Pune To Adlabs Imagica Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Book Pune To Mahabaleshwar Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Book Pune To Trimbakeshwar Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune Mumbai Pune Round Trip",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Mumbai Pune Pickup Drop",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Outstation Cabs From Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service In Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "12 Jyotirlinga Yatra From Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune To Grishneshwar Cab Services",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Pune To Malshej Ghat Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune To Pandharpur Cab Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune To Panhala Fort Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune To Raigad Fort Cab Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune To Satara Kas Pathar Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Pune To Shirdi Cab Pickup Drop",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   
      
    const productSchema = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Book Pune To Devkund Cab",
        "description": "Book Pune To Devkund taxi services, one-way taxi, round trip, luxury taxi, drop taxi, and car rental with S9 Travels. Choose from affordable and reliable Pune to Devkund cab booking options for a comfortable and safe journey.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.8",
          "ratingCount": "8569"
        }
      };
      
     
      
      


    return (
        <div>

<Helmet>
        <title>Book Pune To Devkund Cab | S9 Travels | Contact: +91 8850328441</title>
        <meta 
          name="description" 
          content="Book Pune To Devkund taxi, one-way taxi, round trip, luxury taxi, drop taxi, and car rental services with S9 Travels. Get the best fares for Pune to Devkund cab booking for a comfortable, safe, and affordable ride." 
        />
        
        {/* Inject JSON-LD Schema */}
        <script type="application/ld+json">
          {JSON.stringify(productSchema)}
        </script>
      </Helmet>
         
<section className="page-title centred">
      <div className="bg-layer" style={{ backgroundImage: 'url(/images/background/page-title.jpg)' }}></div>
      <div className="auto-container">
        <div className="content-box">
        
          <h1>{cardData.keyword}</h1>
        </div>
      </div>
    </section>

      

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/4.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                  <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For S9 Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                            <FAQKeyword  faqs={faqData} />

                                                {/* <FAQKeyword faqData={faqData} /> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />
                         

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #252E5B',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#252E5B' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918850328441" className="d-block  text-white">+91 8850328441</a>
                                                <a href="tel:+919552526916" className="d-block  text-white">+91 9552526916</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@s9travels.com" className=" text-white d-block">
                                                    booking@s9travels.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> S9 Travels <br/>
                                                    Khandesh Nagar, Ghandharva Nagri, Moshi,Pune, pin-412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Bookpunetodevkundcab;